/**
 *	shop-list-title.conf.js
 */
 
import angular from 'angular';
import shopListTitleDirective from './shop-list-title.directive.js';

export default angular.module('shop-list-title', [])
	.directive('shopListTitle', shopListTitleDirective)
	.name;